import { render, staticRenderFns } from "./ExportationFrameWalkingChartPropulsionRatio.vue?vue&type=template&id=10c61c06&scoped=true&"
import script from "./ExportationFrameWalkingChartPropulsionRatio.vue?vue&type=script&lang=js&"
export * from "./ExportationFrameWalkingChartPropulsionRatio.vue?vue&type=script&lang=js&"
import style0 from "./ExportationFrameWalkingChartPropulsionRatio.vue?vue&type=style&index=0&id=10c61c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c61c06",
  null
  
)

export default component.exports